module.exports = __webpack_public_path__ + "static/media/Fortmatic.7282e207.svg";